module.exports = __webpack_public_path__ + "static/img/tab-one-active.4a69c742.png";